import styled from 'styled-components';

interface ITableContainer {
  justifyContent?: string;
  selected?: boolean;
  onClick?: () => void;
  isSelectingFiles?: boolean;
}

export const TableContainer = styled.div<ITableContainer>`
  table {
    tbody {
      tr {
        cursor: ${({ isSelectingFiles }) => isSelectingFiles ? 'pointer' : 'default'};

        opacity: ${({ isSelectingFiles, selected }) => isSelectingFiles ? (selected ? 1 : 0.5) : ''};
        border: ${({ isSelectingFiles, selected, theme }) => isSelectingFiles ? (selected ? `2px solid ${theme.colors.primary.main} ` : '') : ''};
      }
    }
  }

      small {
        background: ${({ theme }) => theme.colors.blue[50]};
        color: ${({ theme }) => theme.colors.blue[900]};
        font-weight: bold;
        text-transform: uppercase;
        padding: 4px;
        border-radius: 4px;
        margin-left: 8px;
        font-size: 10px;
      }

      small.green {
          background: ${({ theme }) => theme.colors.green[100]};
          color: ${({ theme }) => theme.colors.green[500]};
      }

      small.orange {
          background: ${({ theme }) => theme.colors.orange[100]};
          color: ${({ theme }) => theme.colors.orange[500]};
        }

      small.gray {
        background: ${({ theme }) => theme.colors.gray[100]};
        color: ${({ theme }) => theme.colors.gray[900]};
      }

      small.red {
        background: ${({ theme }) => theme.colors.danger.light};
        color: ${({ theme }) => theme.colors.danger.dark};
      }
`;

export const StyledTr = styled.tr<ITableContainer>`
        opacity: ${({ isSelectingFiles, selected }) => isSelectingFiles ? (selected ? 1 : 0.5) : ''};
        border: ${({ isSelectingFiles, selected, theme }) => isSelectingFiles ? (selected ? `2px solid ${theme.colors.primary.main} ` : '') : ''};
        transition: all 0.2s ease-in-out;

        td {
          font-size: 12px;
          img {
            width: 24px;
            cursor: pointer;
            &:hover{
              opacity: 0.5;
              transition: ease-in 0.2s;
            }
            &:not(:hover) {
              opacity: 1;
              transition: ease-in 0.2s;
            }
          }
        }
`;
